import { FC, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import CustomPopup from "../CustomPopup/CustomPopup";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { Colors } from "../../styles/constant";
import extendedRateUsPopupImage from "../../assets/images/extendedRateUsPopup-image.svg";
import CustomLink from "../CustomLink/CustomLink";
import useCmsPageVariables from "../../hooks/useCmsPageVariables";
import {
  extendedFeedbackPopupCtaText,
  extendedFeedbackPopupSubTitle,
  extendedFeedbackPopupTitle,
} from "../../utils/constants";

interface ExtendedFeedbackPopupProps {
  open: boolean;
  handleClose: () => void;
}

const ExtendedFeedbackPopup: FC<ExtendedFeedbackPopupProps> = ({
  open,
  handleClose,
}) => {
  const [selectedStars, setSelectedStars] = useState<number>(0);
  const extendedFeedbackPopupData = useCmsPageVariables(
    "extended-npsFeedback-popup"
  );

  const handleStarClick = (index: number) => {
    setSelectedStars((prev) => (prev === index + 1 ? index : index + 1));
  };

  return (
    <CustomPopup open={open} handleOpen={handleClose}>
      <Box
        gap={"1.875rem"}
        padding={"2rem 1.1875rem 2rem 1rem"}
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          gap="1.25rem"
          alignItems="center"
        >
          <Typography
            variant="h5"
            lineHeight="120%"
            letterSpacing=".0938rem"
            color={Colors.textBlackV1}
          >
            {extendedFeedbackPopupData?.attributes?.title ||
              extendedFeedbackPopupTitle}
          </Typography>
          <img src={extendedRateUsPopupImage} />
        </Box>
        <Typography
          variant="h5"
          fontWeight="500"
          lineHeight="100%"
          color={Colors.darkGray}
        >
          {extendedFeedbackPopupData?.attributes?.text ||
            extendedFeedbackPopupSubTitle}
        </Typography>

        {/* Stars Row */}
        <Box display="flex" gap=".5356rem">
          {[...Array(5)].map((_, index) => (
            <StarRoundedIcon
              key={index}
              onClick={() => handleStarClick(index)}
              sx={{
                color: index < selectedStars ? Colors.iconYellow : "#D5D7DE",
                fontSize: "2.5rem",
                cursor: "pointer",
              }}
            />
          ))}
        </Box>

        <Box
          display="flex"
          width="100%"
          gap=".625rem"
          alignItems="center"
          flexDirection="column"
        >
          <Button
            fullWidth
            variant="contained"
            className="popup-btn"
            sx={{
              borderRadius: "4.25rem",
              padding: "1rem 2.625rem",
              cursor: "pointer",
            }}
          >
            <Typography variant="h4">
              {extendedFeedbackPopupData?.attributes?.urlLable ||
                extendedFeedbackPopupCtaText}
            </Typography>
          </Button>
          <CustomLink
            title="No Thanks"
            titleSize=".75rem"
            onClick={handleClose}
          ></CustomLink>
        </Box>
      </Box>
    </CustomPopup>
  );
};

export default ExtendedFeedbackPopup;
